import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "faq" }
const _hoisted_2 = { class: "faq-accordion" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "faq-content" }
const _hoisted_6 = { class: "footer" }

import ContactDialog from "./ContactDialog.vue";
import { ref } from "vue";
import CommonButton from "./CommonButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const dialog = ref<InstanceType<typeof ContactDialog>>();
const showDialog = ref(false);
const qaList = [
  {
    q: "どのように応募すればよいですか？",
    a: "案件画面下の「応募」ボタンからお願いします",
  },
  {
    q: "下書きの確認中に掲載期日が過ぎてしまい、投稿していいのかが分からない",
    a: "クライアント企業様の状況により、掲載期日が過ぎている状態でも下書きのお戻しが遅くなる場合がございます。その際は下書きの確認が完了してからの投稿で問題ございません。※クライアント企業様のInstagramアカウントへのDM等、直接の連絡はご遠慮いただけますと幸いです。※SPADアプリ内、弊社公式Instagramアカウント、LINE公式アカウントのいずれかより、別途ご案内させていただく場合がございます。その際には案内に従っていただけますと幸いです。ご不明な点ありましたら、下記よりお問い合わせいただけますと幸いです。",
  },
  {
    q: "お支払い通知書はいつ発行されるか",
    a: "案件終了後の翌月の20日前後に発行されます。例えば、10月1日に案件が終了した場合は、11月20日前後の支払い通知書発行となります。",
  },
  {
    q: "弊社案件の報酬のお支払日は投稿月の翌月末となります。",
    a: "件終了後の翌月の20日前後に発行されます。",
  },
  {
    q: "お支払金額として記載された金額は報酬として貰える金額、自分が支払う金額のどちらでしょうか",
    a: "案件を実施した際にOMOTinfluencerからインフルエンサーの方に対してお支払する金額になります。",
  },
  {
    q: "フォロワー数と投稿数が更新されない",
    a: "フォロワー数と投稿数はリアルタイムには反映されません。",
  },
];

const contact = () => {
  showDialog.value = true;
  dialog.value?.openContactDialog();
};
// import { router } from 'vue-router'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" FAQ "),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("header", { class: "header" }, [
        _createElementVNode("p", null, "よくある質問")
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(qaList, (qa, index) => {
          return _createElementVNode("section", { key: index }, [
            _createElementVNode("input", {
              id: 'faq-' + `${index}`,
              type: "checkbox",
              class: _normalizeClass(["toggle", ['toggle' + index]])
            }, null, 10 /* CLASS, PROPS */, _hoisted_3),
            _createElementVNode("label", {
              class: "label",
              for: 'faq-' + `${index}`
            }, [
              _createElementVNode("p", null, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Q ", -1 /* HOISTED */)),
                _createTextVNode(_toDisplayString(qa.q), 1 /* TEXT */)
              ])
            ], 8 /* PROPS */, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, "A ", -1 /* HOISTED */)),
              _createTextVNode(_toDisplayString(qa.a), 1 /* TEXT */)
            ])
          ])
        }), 64 /* STABLE_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CommonButton, {
          data: {
          status: 0,
          button: `お問い合わせはこちら`,
        },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (contact()))
        })
      ])
    ]),
    _createVNode(ContactDialog, {
      ref_key: "dialog",
      ref: dialog,
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event))
    }, null, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})